import React, { useState } from 'react';
import { useLang } from '../contexts/LanguageContext';
import apiUrls from '../api/apiUrls';
import fetchWithAuth from '../api/fetchWithAuth';

const initialFormState = { text: '', website: '', formName: '' };

const QuestionForm = ({ formName = "" }) => { // Accept formName as a prop
  // Variable de traducción
  const { t } = useLang();

  // State for form validation
  const [formData, setFormData] = useState(initialFormState);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.text?.trim()) {
      setError(t("CONTACT_FORM_ERROR"));
      return;
    }
    setError('');
    setSuccessMessage('');
    setSubmitted(false);

    // Ensure formName is included in formData
    const updatedFormData = { ...formData, formName };

    const clientMetadata = {
      pageUrl: typeof window !== "undefined" ? window.location.href : "",
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      locale:
        typeof navigator !== "undefined"
          ? navigator.language || (navigator.languages && navigator.languages[0]) || ""
          : "",
      ip: "",
    };

    try {
      if (typeof fetch === "function") {
        try {
          const ipResponse = await fetch("https://api.ipify.org?format=json");
          if (ipResponse.ok) {
            const { ip } = await ipResponse.json();
            clientMetadata.ip = ip;
          }
        } catch {
          // Non-blocking: ignore IP lookup failures
        }
      }

      const payload = { ...updatedFormData, metadata: clientMetadata };
      const response = await fetchWithAuth(apiUrls.apiFeedback, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        setError(t("CONTACT_FORM_SUBMIT_ERROR"));
        return;
      }

      const result = await response.json();

      if (result?.success) {
        setSuccessMessage(t("CONTACT_FORM_SUBMIT_SUCCESS"));
        setSubmitted(true);
        setFormData({ ...initialFormState });
      } else {
        setError(t("CONTACT_FORM_SUBMIT_ERROR"));
        return;
      }
    } catch (error) {
      setSubmitted(false);
      setError((prev) => prev || t("CONTACT_FORM_SUBMIT_ERROR"));
    }
  };

  return (
    <div>
      <div className="m-10 container" style={{ width: "90%" }}>
        {submitted ? (
          <div className="py-4 text-center">
            <p className="text-success fw-bold mb-0">
              {successMessage || t("CONTACT_FORM_SUBMIT_SUCCESS")}
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} name={formName}>
            <p className="mb-3 text-muted">
              {t("CONTACT_FORM_ENCOURAGEMENT") || "Cuéntanos en qué podemos mejorar. Leemos cada mensaje."}
            </p>
            <div className="mb-3">
              <label htmlFor="text">{t("CONTACT_FORM_MESSAGE")}:</label>
              <textarea
                name="text"
                id="text"
                className="form-control"
                maxLength="1000"
                rows="5"
                placeholder={t("CONTACT_FORM_MESSAGE_PLACEHOLDER")}
                value={formData.text}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <input type="text" name="website" id="website" defaultValue="ad" style={{ display: "none" }} />
            {error && <p className="text-danger fw-bold">{error}</p>}
            <button className="btn btn-primary">{t("CONTACT_FORM_SUBMIT")}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default QuestionForm;
